import React, { useEffect } from "react";
import { Button, Row, Col, ListGroup, Image, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../../components/Message";
import CheckoutSteps from "../../components/CheckoutSteps";
import { Link, useNavigate } from "react-router-dom";
import { setItemsPrice, setShippingPrice, setTaxPrice, setTotalPrice } from "../../services/cart/CartSlice";
import { createOrder } from "../../services/order/OrderCreateSlice";

const PlaceOrderScreen = () => {
  const cart = useSelector((state) => state.cart);
  const {itemsPrice,taxPrice,shippingPrice,totalPrice} = cart
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const addDecimals = (num) => {
    return (Math.round(num*100)/100).toFixed(2)
  }

  const orderCreate = useSelector(state=>state.orderCreate)
  const {order,success,error}=orderCreate

  const placeOrderHandler = () => {
    dispatch(createOrder({
        orderItems:cart.cartItems,
        shippingAddress:cart.shippingAddress,
        itemsPrice:cart.itemsPrice,
        shippingPrice:cart.shippingPrice,
        taxPrice:cart.taxPrice,
        totalPrice:cart.totalPrice,
        paymentMethod:cart.paymentMethod
    }))
}

useEffect(()=>{
        dispatch(setItemsPrice(cart.cartItems.reduce((acc,item)=>acc+item.price*item.qty,0)))
        dispatch(setShippingPrice(itemsPrice>100?0:100))
        dispatch(setTaxPrice(addDecimals(Number((0.15*itemsPrice).toFixed(2)))))
        dispatch(setTotalPrice(Number(itemsPrice)+Number(shippingPrice+Number(taxPrice))))
        // eslint-disable-next-line
  },[dispatch,itemsPrice,taxPrice,shippingPrice,totalPrice])

  useEffect(()=>{
    if(success){
        navigate(`/orders/${order._id}`)
    }

    // eslint-disable-next-line
  },[navigate,success])

  return (
    <>
      <CheckoutSteps step1 step2 step3 step4 />
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Shipping</h2>
              <p>
                <strong>Address:</strong>
                {cart.shippingAddress.address},{cart.shippingAddress.city},
                {cart.shippingAddress.postalCode},{cart.shippingAddress.country}
              </p>
            </ListGroup.Item>
            <ListGroup.Item>
              <h2>Payment Method</h2>
              <strong>Method: </strong>
                {cart.paymentMethod}
            </ListGroup.Item>
            <ListGroup.Item>
              <h2>Order Items</h2>
                {cart?.cartItems?.length===0?<Message>Your cart is empty</Message>:(
                    <ListGroup variant="flush">
                        {cart?.cartItems?.map((item,index)=> (
                            <ListGroup.Item key={index}>
                                <Row>
                                    <Col md={1}>
                                        <Image src={item.image} alt={item.name} fluid rounded />
                                    </Col>
                                    <Col>
                                        <Link to={`/product/${item.product}`}>
                                            {item.name}
                                        </Link>
                                    </Col>
                                    <Col md={4}>
                                        {item.qty} x ${item.price} = ${item.qty * item.price}
                                    </Col>
                                </Row> 
                            </ListGroup.Item>
                        ))

                        }
                    </ListGroup>
                )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
            <Card>
                <ListGroup variant="flush">
                <ListGroup.Item>
                <h5>Test Payment Credentials</h5>
                <p>Email: test@test.123.com <br /> Password: 12345678</p>
                
              </ListGroup.Item>
                    <ListGroup.Item>
                        <h2>Order Summary</h2>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <Row>
                            <Col>Items</Col>
                            <Col>${cart.itemsPrice}</Col>
                        </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <Row>
                            <Col>Shipping</Col>
                            <Col>${cart.shippingPrice}</Col>
                        </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <Row>
                            <Col>Tax</Col>
                            <Col>${cart.taxPrice}</Col>
                        </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <Row>
                            <Col>Total</Col>
                            <Col>${cart.totalPrice}</Col>
                        </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        {error && <Message variant="danger">{error}</Message>}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <Button type="button" className="btn-block" disabled={cart.cartItems.length===0} 
                            onClick={placeOrderHandler}
                        >Place Order</Button>
                    </ListGroup.Item>
                </ListGroup>
            </Card>
        </Col>
      </Row>
    </>
  );
};

export default PlaceOrderScreen;
